import { createSlice } from '@reduxjs/toolkit'
import { ProgramInitialResponseState } from '../types/programDetailsTypes'

const initialState: ProgramInitialResponseState = {
  content: [],
  selected: null,
  programId: null,
  totalPages: null,
  shouldRefetchEmails: false,
}

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    updatePrograms: (state, action) => {
      state.content = action.payload
    },
    updateProgramsByPage: (state, action) => {
      state.totalPages = action.payload
    },
    updateSelectedProgram: (state, action) => {
      state.selected = action.payload
    },
    updateCreateProgram: (state, action) => {
      state.programId = action.payload.id
    },
    resetSelectedProgram: (state) => {
      state.selected = null
    },
    deleteProgramAction: () => {
      return
    },
    createProgramAction: (state, action) => {
      state.programId = action.payload.id
    },
    getSingleProgramAction: (state, action) => {
      state.programId = action.payload.id
    },
    updateProgramAction: (state, action) => {
      state.programId = action.payload.id
    },
    updateDisableProgramAction: () => {
      return
    },
    getAllProgramsAction: () => {
      return
    },
    patchToggleUpdateBulkDisableActionProgram: () => {
      return
    },
    triggerEmailRefetch: (state) => {
      state.shouldRefetchEmails = true
    },
    resetEmailRefetch: (state) => {
      state.shouldRefetchEmails = false
    },
  },
})

export const {
  createProgramAction,
  getSingleProgramAction,
  updateSelectedProgram,
  updateCreateProgram,
  updateProgramAction,
  getAllProgramsAction,
  updateDisableProgramAction,
  updatePrograms,
  resetSelectedProgram,
  deleteProgramAction,
  patchToggleUpdateBulkDisableActionProgram,
  updateProgramsByPage,
  triggerEmailRefetch,
  resetEmailRefetch,
} = programSlice.actions

export default programSlice.reducer
